import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/apiService";

export const GetAllTG_PalestinianGovernoratesName = createAsyncThunk(
  "dropdowns/GetAllTG_PalestinianGovernoratesName",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllTG_PalestinianGovernoratesName"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetListPalestinianGovernorates = createAsyncThunk(
  "ListPalestinianGovernorates/GetListPalestinianGovernorates",
  async (tG_MainTargetedGroupId, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/TG_PalestinianGovernoratesProjectActivities/GetTG_PalestinianGovernoratesProjectActivitiesListData",
        {
          tG_MainTargetedGroupId: tG_MainTargetedGroupId,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const DropDownPalestinianGovernoratesName = createSlice({
  name: "DropDownPalestinianGovernoratesName",
  initialState: {
    DropDownPalestinianGovernoratesName: [],
    loadingDropDownPalestinianGovernoratesName: false,
    errorDropDownPalestinianGovernoratesName: null,
    PalestinianGovernoratesList: [],
    loadingPalestinianGovernoratesList: false,
    errorPalestinianGovernoratesList: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(
        GetAllTG_PalestinianGovernoratesName.pending,
        (state, action) => {
          state.loadingDropDownPalestinianGovernoratesName = true;
          state.DropDownPalestinianGovernoratesName = action.payload;
          state.errorDropDownPalestinianGovernoratesName = null;
        }
      )
      .addCase(
        GetAllTG_PalestinianGovernoratesName.fulfilled,
        (state, action) => {
          state.loadingDropDownPalestinianGovernoratesName = false;
          state.DropDownPalestinianGovernoratesName = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(
        GetAllTG_PalestinianGovernoratesName.rejected,
        (state, action) => {
          state.loadingDropDownPalestinianGovernoratesName = false;
          state.errorDropDownPalestinianGovernoratesName = action.payload;
        }
      )
      .addCase(GetListPalestinianGovernorates.pending, (state, action) => {
        state.loadingPalestinianGovernoratesList = true;
        state.PalestinianGovernoratesList = action.payload;
        state.errorPalestinianGovernoratesList = null;
      })
      .addCase(GetListPalestinianGovernorates.fulfilled, (state, action) => {
        state.loadingPalestinianGovernoratesList = false;
        state.PalestinianGovernoratesList = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetListPalestinianGovernorates.rejected, (state, action) => {
        state.loadingPalestinianGovernoratesList = false;
        state.errorPalestinianGovernoratesList = action.payload;
      });
  },
});

export default DropDownPalestinianGovernoratesName.reducer;
